module.exports = __webpack_public_path__ + "static/tw-activity-tab-3230df010e99eb07f7c418851afe6900.jpg";